import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { ThemeStateService } from '@sites/site-theme/src/state';
import type { SettingsFormGroup, SettingsFormType } from '@web/widgets/catalog-products/type';
import { CSS_RESTRICTIONS } from '@common/constants';
import { CommonModule } from '@angular/common';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { CardSettingsComponent } from './card-settings/card-settings.component';
import { GallerySettingsComponent } from './gallery-settings/gallery-settings.component';
import { TypographySettingsComponent } from './typography-settings/typography-settings.component';

@Component({
    selector: 'web-general-settings',
    templateUrl: './general-settings.component.html',
    styleUrls: ['./general-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        CommonElementsModule,
        CardSettingsComponent,
        GallerySettingsComponent,
        TypographySettingsComponent,
    ],
})
export class GeneralSettingsComponent extends WebBaseControlTypedSettingsComponent<SettingsFormGroup> {
    @Input() public widgetId: string;

    private readonly themeState = inject(ThemeStateService);

    public readonly selectedThemeColors = this.themeState.selectedColors;

    public setMargin(value: number) {
        this.generalSettings.get('margin').setValue(value);
    }

    public get generalSettings(): SettingsFormType['general'] {
        return this.itemForm.get('general') as SettingsFormType['general'];
    }

    public get cardSettings(): SettingsFormType['card'] {
        return this.itemForm.get('card') as SettingsFormType['card'];
    }

    public get gallerySettings(): SettingsFormType['gallery'] {
        return this.itemForm.get('gallery') as SettingsFormType['gallery'];
    }

    public get typographySettings(): SettingsFormType['typography'] {
        return this.itemForm.get('typography') as SettingsFormType['typography'];
    }

    public get MARGIN_MIN(): number {
        return CSS_RESTRICTIONS.MARGIN_MIN;
    }

    public get MARGIN_MAX(): number {
        return CSS_RESTRICTIONS.MARGIN_MAX;
    }
}
